import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArray',
  pure: false
})
export class FilterArrayPipe implements PipeTransform {

  public transform(items: any[], filteredKey: any): any {
    return items.map(x => {
      x.disabled = x.id <= filteredKey && x.id !== null;
      return x;
    });
  }

}
